



















































import aws from '@/aws-exports.js';
import {Component, Vue} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

import GuestToolbar from '@/components/Guest/GuestToolbar.vue';
import GuestHero from '@/components/Guest/GuestHero.vue';
import GuestTalk from '@/components/Guest/GuestTalk.vue';
import GuestInfo from '@/components/Guest/GuestInfo.vue';
import GuestScreenshots from '@/components/Guest/GuestScreenshots.vue';
import GuestScreenshots2 from '@/components/Guest/GuestScreenshots2.vue';
import S3Image from '@/components/S3Image.vue';
import GuestAbout from '@/components/Guest/GuestAbout.vue';
import Glide from '@glidejs/glide';

@Component({
  components: {
    GuestAbout,
    S3Image,
    GuestScreenshots2,
    GuestScreenshots,
    GuestInfo,
    GuestTalk,
    GuestHero,
    GuestToolbar,
  },
})
export default class Layout extends Vue {
  @Action('guest/animals/read') private readAnimals!: () => Promise<void>;
  @Getter('guest/animals/all') private animals!: any;

  private baseUrl: string = 'https://s3-eu-west-1.amazonaws.com/' + aws.aws_user_files_s3_bucket + '/public/';

  private async mounted() {
    if (this.$route.hash) {
      this.$vuetify.goTo(this.$route.hash);
    }

    await this.readAnimals();

    if (this.animals.length > 0) {
      setTimeout(() => {
        new Glide('.glide', {
          type: 'carousel',
          startAt: 0,
          perView: 4,
          autoplay: 2000,
          breakpoints: {
            600: {
              perView: 1,
            },
            1264: {
              perView: 2,
            },
            1904: {
              perView: 3,
            },
          },
        }).mount();
      }, 200);
    }
  }
}
